import { getRasterType } from '@screens/Map/components/Tiles/utils';
import { useSelector } from 'react-redux';
import type { RootState } from '../redux/reducers';

type Props = {
  useSide?: boolean;
};

const DEFAULT_PROPS: Props = { useSide: false };

/**  Always load userPreferences using this hook */
export function usePreferences({ useSide }: Props = DEFAULT_PROPS) {
  const { colorMaps, selectedColorMap, selectedIndex, contrastPalette } = useSelector(
    (state: RootState) => state.User.userPreferences
  );

  const contrastRasterType = getRasterType('ndvi', contrastPalette);

  const { selected_index: mapIndex } = useSelector((state: RootState) => state.Map.sideMap);

  const index = useSide ? mapIndex : selectedIndex;

  return { colorMaps, selectedColorMap, selectedIndex: index, contrastPalette, contrastRasterType };
}
